import type { DriverPlanningInputLine } from "./driverPlanningsConnectors";

type DriverPlanningHeaderColumn = {
  field: keyof DriverPlanningInputLine;
  acceptedHeaders: string[];
};

export const driverPlanningHeaderColumns = [
  {
    field: "driverIdNumber",
    acceptedHeaders: ["Code salarié"],
  },
  {
    field: "startDate",
    acceptedHeaders: ["Date début intervention", "Date début"],
  },
  {
    field: "startTime",
    acceptedHeaders: ["Heure début intervention", "Heure début"],
  },
  {
    field: "endTime",
    acceptedHeaders: ["Heure fin intervention", "Heure fin"],
  },
  {
    field: "expectedMileage",
    acceptedHeaders: ["Kilomètres"],
  },
  {
    field: "driverCity",
    acceptedHeaders: ["Commune", "Commune Conducteur"],
  },
  {
    field: "clientName",
    acceptedHeaders: ["Nom usuel du membre", "Nom Client"],
  },
  {
    field: "clientFirstName",
    acceptedHeaders: ["Prénom", "Prénom Client"],
  },
  {
    field: "clientCity",
    acceptedHeaders: ["Commune_1", "Commune Client"],
  },
  {
    field: "activityType",
    acceptedHeaders: ["Nom Rubrique", "Type d'activité"],
  },
] as const satisfies readonly DriverPlanningHeaderColumn[];
